import React from "react";
import { useHistory } from "react-router";
import { Layout, Form, Input, Button, Result, notification } from "antd";
import { LockOutlined } from "@ant-design/icons";
import { reset as resetPasswordApi } from "../../api/Password";

const { Content } = Layout;

const ResetPasswordForm = (props) => {
  const { email, data, signature } = props;
  const [formNewPassword] = Form.useForm();
  let [loading, setLoading] = React.useState(false);
  let [success, setSuccess] = React.useState(false);
  let history = useHistory();

  const onFinish = () => {
    formNewPassword.validateFields()
      .then(() => {
        setLoading(true);

        let values = formNewPassword.getFieldsValue();
        let payload = {
          "email": email,
          "password": values.password
        };

        resetPasswordApi(data, signature, payload)
          .then((data) => {
            if (!!data.msg) {
              throw new Error(data.msg);
            }

            setTimeout(() => {
              setSuccess(true);
              setLoading(false);
            }, 1000);
          })
          .catch(error => {
            setLoading(false);

            setTimeout(() => {
              if (error.message === "Expired signature") {
                props.onExpiredToken();
              } else {
                props.onError();
              }
            }, 1000);
          });
      })
      .catch((error) => {
        notification['error']({
          message: "Pensez à bien vérifier les informations que vous avez saisi."
        });
      });
  };

  if (success) {
    return (
      <Result
        className="result_password_reset"
        style={{ paddingTop: 0 }}
        status="success"
        title="Le mot de passe à bien été enregistré"
        subTitle="Vous pouvez désormais vous connectez avec vos nouveaux identifiants"
        extra={[
          <Button
            key="login"
            type="primary"
            onClick={() => history.push("/login")}
          >
            Se connecter
          </Button>
        ]}
      />
    );
  }

  return (
    <Content>
      <Form
        name="reset_password"
        form={formNewPassword}
      >
        <Form.Item
          name="password"
          rules={[{
            required: true,
            message: "Le password ne peut pas être vide"
          }, {
            min: 6,
            message: "Le mot de passe est trop faible, il doit avoir au moins 6 caratères"
          }]}
          hasFeedback
        >
          <Input.Password
            prefix={<LockOutlined className="site-form-item-icon" />}
            placeholder="Mot de passe"
          />
        </Form.Item>

        <Form.Item
          name="confirm"
          dependencies={["password"]}
          hasFeedback
          rules={[{
            required: true,
            message: "Le password ne peut pas être vide",
          }, {
            min: 6,
            message: "Le mot de passe est trop faible, il doit avoir au moins 6 caratères"
          }, ({ getFieldValue }) => ({
            validator(_, value) {
              if (!value || getFieldValue("password") === value) {
                return Promise.resolve();
              }

              return Promise.reject(
                new Error("Le mot de de passe ne correspond pas!")
              );
            }
          })]}
        >
          <Input.Password
            prefix={<LockOutlined className="site-form-item-icon" />}
            placeholder="Confirmation du mot de passe"
          />
        </Form.Item>

        <Form.Item>
          <Button
            type="primary"
            htmlType="submit"
            loading={loading}
            onClick={() => onFinish()}
          >
            Enregister
          </Button>
        </Form.Item>
      </Form>
    </Content>
  );
};

export default ResetPasswordForm;
